import Button from 'react-bootstrap/Button';
import PropTypes from "prop-types";
import React from "react";
import InputPlusAndMinus from "../../shared-components/InputPlusAndMinus";
import { Container, Col, Row } from 'react-bootstrap';

class OrderItemAdditonalUsers extends React.Component {
  state = {
    defaultUserCount: 0,
    additionalUsers: 0,
    packageTotal: 0,
    packagePrice: 0,
    extrauserprice: 0
  };

  componentDidMount() {
    const {
      defaultUserCount,
      extrauserprice,
      price,
      additionalUsers
    } = this.props.packageItem;

    // check to see if the prevState and the props are the same, if so don't set state
    this.setState((prevState, props) => {
      if (prevState.additionalUsers !== props.additionalUsers) {
        return {
          defaultUserCount,
          extrauserprice: parseFloat(extrauserprice, 10),
          packagePrice: parseFloat(price, 10),
          additionalUsers: additionalUsers || 0
        };
      }
    });
  }

  getTotal = () => {
    return (
      parseFloat(this.state.packagePrice) +
      parseFloat(this.state.extrauserprice) * this.state.additionalUsers
    );
  };

  updateAdditionalUsers = (amount, packageItem) => {
    const additionalUsers = amount;
    this.setState({ additionalUsers });
    packageItem.additionalUsers = additionalUsers;
    this.props.updateBasket(packageItem);
  };

  render() {
    const { packageItem, removePackageFromBasket } = this.props;
    const { additionalUsers } = this.state;

    return (
      <Container fluid="true">
        <Row className="order-drawer__selection">
          <Col xs={11} className="order-drawer__selection-info">
            <Row className="order-drawer__selection-details">
              <Col xs={10}>
                <strong>{packageItem.Name}</strong>{" "}
              </Col>
              <Col xs={2}>
                £{parseFloat(packageItem.price)}
              </Col>
            </Row>

            <Row className="order-drawer__add-container">
              <Col xs={10}>
                <Row className="order-drawer__selection-details">
                  <Col xs={3} sm={7}>
                    <strong>Additional simultaneous sessions*</strong>
                  </Col>
                  <Col xs={6} sm={4} className="order-drawer__plus-minus-container">
                    <InputPlusAndMinus
                      max={30}
                      min={0}
                      updateFunction={value =>
                        this.updateAdditionalUsers(value, packageItem)
                      }
                      defaultValue={packageItem.additionalUsers}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={2}>
                £
                {additionalUsers > 0
                  ? additionalUsers * parseFloat(packageItem.extrauserprice)
                  : 0}
              </Col>
            </Row>

            <hr />

            <Row>
              <Col xs={10} />
              <Col xs={2}>
                <strong>£{this.getTotal()}</strong>
              </Col>
            </Row>
          </Col>

          <Col xs={1} className="order-drawer__delete">
            <Button variant="danger"
              className="order-drawer__delete-btn"
              aria-label="Delete"
              onClick={e => removePackageFromBasket(packageItem)}
            >
              <i className="far fa-times-circle"></i>
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

OrderItemAdditonalUsers.propTypes = {
  packageItem: PropTypes.object,
  removePackageFromBasket: PropTypes.func,
  addUsers: PropTypes.func,
  updateBasket: PropTypes.func
};

export default OrderItemAdditonalUsers;
